<template>
  <div
    class="card-container car-created"
    :class="{ 'modal-mode': modalMode === 'logged-in' }"
  >
    <div class="content">
      <template v-if="!loading">
        <p v-if="errorMessage">
          {{ errorMessage }}
        </p>
        <p v-else>
          Samochód został pomyślnie dodany do listy! <br>
          Czy chcesz umówić dla niego nową wizytę?
        </p>
      </template>
      <div v-else>
        <spinner :line-fg-color="thirdColor" />
      </div>
    </div>
    <div
      class="buttons"
      v-if="!loading && !errorMessage"
    >
      <standard-button
        text="Tak, umów wizytę"
        custom-class="appoint-visit-button"
        @buttonClick="newVisit()"
        :background-color="primaryColor"
      />
    </div>
  </div>
</template>

<script>
import StandardButton from '~/StandardButton';
import Spinner from 'vue-simple-spinner';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    StandardButton,
    Spinner,
  },
  data() {
    return {
      carAdded: false,
      errorMessage: '',
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      primaryColor: 'brand/getPrimaryColor',
      modalMode: 'modal/getModalMode',
      thirdColor: 'brand/getThirdColor',
      car: 'car/getChosenCarSpecs',
      chosenCar: 'car/getChosenCarSpecs',
      authStatus: 'auth/getAuthStatus',
    }),
    withLogin() {
      return this.authStatus.loggedIn;
    },
  },
  methods: {
    ...mapActions({
      closeModal: 'modal/closeModal',
      addCar: 'myCars/addNewCar',
      resetCarSpecs: 'car/resetCarSpecs',
      resetFilters: 'car/resetFilters',
      setSelectedLicensePlate: 'visit/setSelectedLicensePlate',
      setSelectedVin: 'visit/setSelectedVin',
      setSelectedCarModelID: 'visit/setSelectedCarModelID',
      setModalContent: 'modal/setContent',
      setSelectedServices: 'visit/setSelectedServices',
      setSelectedVisitDate: 'visit/setSelectedVisitDate',
      setRegisteredVisit: 'visit/setRegistered',
      setSelectedPrice: 'visit/setSelectedPrice',
      setSelectedPartner: 'visit/setSelectedPartner',
      setMileage: 'visit/setMileage',
    }),
    newVisit() {
      this.closeModal();
      this.resetVisitSpecs();
      this.setSelectedVin(this.car.vin);
      this.setSelectedCarModelID(this.chosenCar.id);
      this.setSelectedLicensePlate(this.car.licensePlate);
      this.$router.push({ path: `/dashboard/visits/new/${this.chosenCar.id}/station` });
    },
    resetVisitSpecs() {
      this.setSelectedPartner(null);
      this.setSelectedServices(null);
      this.setSelectedVisitDate(null);
      this.setRegisteredVisit(null);
      this.setMileage(0);
    },
    handleKeyDown(event) {
      const { keyCode } = event;
      if (keyCode === 13 && !this.errorMessage && !this.loading) {
        this.newVisit();
      }
    },
  },
  mounted() {
    this.setModalContent({
      title: !this.withLogin ? 'Umów się na wizytę' : 'Dodaj samochód',
    });

    this.loading = true;
    this.addCar(this.car)
      .then((res) => {
        // eslint-disable-next-line
        if (res !== undefined && res.status != 200) {
          this.errorMessage = res.message;

          if (res.status === 403 && res.message === 'Nie masz wystarczających uprawnień do wyświetlenia zasobu') {
            this.$router.push({ path: '/' });
            this.closeModal();
          }
        }
        this.loading = false;
      });
    this.resetFilters();

    document.addEventListener('keydown', this.handleKeyDown, false);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
};
</script>
